module.exports = function abortCb(cb, abort, onAbort) {
  cb(abort)
  onAbort && onAbort(abort === true ? null: abort)
  return
}




//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/util/abort-cb.js
// module id = 306
// module chunks = 0